import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
function formatRelative(ts) {
    const now = Date.now();
    const ms = typeof ts === "number" ? ts : ts.getTime();
    const diff = Math.max(0, Math.floor((now - ms) / 1000));
    if (diff < 60)
        return `${diff}s`;
    if (diff < 3600)
        return `${Math.floor(diff / 60)}m`;
    if (diff < 86400)
        return `${Math.floor(diff / 3600)}h`;
    const d = new Date(ms);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
}
export default function LastUpdated({ timestamp }) {
    const [, setTick] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => setTick((t) => t + 1), 1000);
        return () => clearInterval(interval);
    }, []);
    return (_jsxs("div", { className: "last-updated", children: [_jsx("span", { className: "live", "aria-hidden": "true" }), _jsx("span", { children: "Last updated" }), _jsx("span", { className: "num", children: formatRelative(timestamp) }), _jsx("span", { children: "ago" })] }));
}
//# sourceMappingURL=LastUpdated.js.map